// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getPenyakit, insertPenyakit, penyakitSelector, updatePenyakit,} from "./penyakitSlice";

import {Colors} from "../../../assets/Colors";

const MasterPenyakitPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const penyakit = useSelector(penyakitSelector);

    useEffect(() => {
        dispatch(
            getPenyakit({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && penyakit.isGetSuccess && !penyakit.isGetFetching) {
            let calc = penyakit?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = penyakit.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (search === "" && penyakit.isGetSuccess && !penyakit.isGetFetching) {
            let calc = penyakit?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = penyakit.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (
            !penyakit?.isGetFetching &&
            penyakit.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = penyakit?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = penyakit.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getPenyakit({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (penyakit.isGetSuccess) {
                alertService.success(penyakit.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getPenyakit({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (penyakit.isUpdateSuccess) {
                alertService.success(penyakit.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updatePenyakit({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetPenyakit(params) {
    //   return dispatch(getPenyakit(params));
    // }

    function handleInsertPenyakit(param) {
        setInsertFetch(true);
        const params = {
            PenyakitName: param.inputOneValue,
        };

        dispatch(insertPenyakit(params));
    }

    function handleUpdatePenyakit(param) {
        setUpdateFetch(true);

        const params = {
            PenyakitName: param.inputOneValue,
            PenyakitID: currentData.PenyakitID,
            status: param.status,
        };
        dispatch(updatePenyakit(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getPenyakit(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getPenyakit(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = penyakit.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? penyakit.count : newCount,
            search: search,
        };
        dispatch(getPenyakit(params));

        setPage(1);
        setCount(newCount === "-1" ? penyakit.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>
                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Penyakit"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Penyakit"
                                tableData={penyakit.data}
                                colOneTitle="ID"
                                colOneData="PenyakitID"
                                colTwoTitle="Nama Penyakit"
                                colTwoData="PenyakitName"
                                status="Status"
                                fetching={penyakit.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Penyakit"
                        inputOneTitle="Nama Penyakit"
                        inputOneValue=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertPenyakit}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.PenyakitID}
                        modal={handleModal}
                        modalTitle="Ubah Penyakit"
                        inputOneTitle="Nama Penyakit"
                        inputOneValue={currentData.PenyakitName}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdatePenyakit}
                    />
                )}
            </div>
        );
    }
};

export default MasterPenyakitPage;
